import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import { Tab, TabGroup, TabList, TabPanels, TabPanel } from "@headlessui/react";
import { useLocation, useNavigate } from "react-router-dom";

import ProfileTab from "./ProfileTab";
import ActivityLogsTab from "./LogsTab";

const Profile = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  //meta title
  document.title = `${props.t("Information")} | ${process.env.REACT_APP_CMS_TITLE}`;

  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabParam = params.get("tab");
    if (tabParam === "activity") {
      setSelectedIndex(1);
    } else {
      setSelectedIndex(0);
    }
  }, [location.search]);

  const handleTabChange = (index) => {
    setSelectedIndex(index);
    navigate(`/profile?tab=${index === 1 ? "activity" : "profile"}`);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={props.t("Profile")} breadcrumbItem={props.t("Profile")} />
          {/* Add your profile information content here */}
          <div className="d-flex flex-column gap-4">
            <TabGroup selectedIndex={selectedIndex} onChange={handleTabChange}>
              <TabList>
                <Tab data-testid="profile-tab">ข้อมูลส่วนตัว</Tab>
                {/* <Tab data-testid="logs-tab">ประวัติการใช้งาน</Tab> */}
              </TabList>
              <TabPanels>
                <TabPanel>
                  <ProfileTab />
                </TabPanel>
                <TabPanel>
                  <ActivityLogsTab />
                </TabPanel>
              </TabPanels>
            </TabGroup>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Profile);
